import { gql } from '@apollo/client';

export default gql`
  query inspectionSubjects(
    $placeId: ID!
    $page: Int
    $name: String
    $serialNumber: String
    $inspectionSubjectId: ID!
  ) {
    space {
      overInspectionsLimit
      adminRole
    }
    inspectionSubjects(placeId: $placeId, page: $page, name: $name, serialNumber: $serialNumber) {
      perPage
      hasNextPage
      inspectionSubjectsTotalPages
      inspectionSubjectsTotal
      inspectionSubjects {
        id
        name
        serialNumber
        incomingInspectionsTotal
        overdueInspectionsTotal
        place {
          id
          name
        }
      }
    }
    inspectionSubject(id: $inspectionSubjectId) {
      id
      name
      serialNumber
    }
  }
`;
